<template>
  <v-card class="pb-1 px-2" tabindex="-1">
    <v-row no-gutters v-if="showBreadCrumbs && result.breadcrumbs.length && !result.isInANoteCard">
      <v-breadcrumbs
        :items="result.breadcrumbs.slice(1, result.breadcrumbs.length - 1)"
        class="pb-2 pt-3 pl-2"
      >
        <template v-slot:item="{ item }">
          <!-- breadcrumbs -->
          <v-breadcrumbs-item link class="grey--text darken-1">
            <v-btn
              small
              text
              plain
              @click="
                openInTab({ pageId: item.id });
                toggleShowSearch(false);
                toggleShowQuickSearch(false);
              "
              class="px-0"
            >
              <page-type-icon
                :pageType="item.type"
                class="mr-1"
                style="opacity: 0.7;"
                size="13px"
              ></page-type-icon>
              <span>{{ item.title | truncate(20) }} </span>
            </v-btn>
          </v-breadcrumbs-item>
        </template>
      </v-breadcrumbs>
    </v-row>
    <v-row
      v-else-if="showBreadCrumbs && result.breadcrumbs.length"
      no-gutters
      @click="
        openInTab({ pageId: result.breadcrumbs[0].id });
        toggleShowSearch(false);
        toggleShowQuickSearch(false);
      "
    >
      <v-col class="shrink pr-3">
        <page-type-icon
          size="22"
          :pageType="result.breadcrumbs[0].type"
          class="pr-0"
        ></page-type-icon>
      </v-col>
      <v-col class="font-weight-medium" style="z-index: 1;">
        {{ result.breadcrumbs[0].title | truncate(30) }}
      </v-col>
      <v-divider class="col-12 my-1 py-2"></v-divider>
    </v-row>
    <v-row
      v-if="!!parent"
      @click="
        openInTab({ pageId: parent.id });
        toggleShowSearch(false);
        toggleShowQuickSearch(false);
      "
      class="px-2 py-1 section-link"
      no-gutters
    >
      <v-col class="shrink pr-3">
        <page-type-icon size="22" :pageType="parent.type" class="pr-0"></page-type-icon>
      </v-col>
      <v-col>
        <span v-text="parent.title"></span>
      </v-col>
    </v-row>
    <v-row
      @click="
        openInTab({ pageId: result.id });
        toggleShowSearch(false);
        toggleShowQuickSearch(false);
      "
      class="pr-4 pl-10 py-1 section-link"
      no-gutters
    >
      <v-col class="shrink pr-3">
        <page-type-icon size="22" :pageType="result.type" class="pr-0"></page-type-icon>
      </v-col>
      <v-col class="">
        <span
          v-for="(string, index) in result.highlightString"
          :key="index"
          :class="{ 'pink lighten-5 rounded': string.highlight }"
          v-text="string.text"
        ></span>
      </v-col>
      <div
        class="ml-2 pl-1"
        style="border-left: 2px solid #efefef; border-radius: 0px; width: 100%;"
      >
        <v-row
          v-for="child in result.children.slice(0, maxChildren)"
          :key="child.id"
          class="pl-7 pr-2"
          no-gutters
        >
          <v-col class="shrink pt-1 px-0">
            <page-type-icon :pageType="child.type" class="mr-1" size="15px"></page-type-icon>
          </v-col>
          <v-col class="caption pt-1"> {{ child.title | truncate }} </v-col>
        </v-row>
      </div>
    </v-row>

    <v-row no-gutters class="">
      <v-col class="caption px-4 pt-2 grey--text">
        Updated {{ result.branchLastUpdated | formatDate('fromNow') }}
      </v-col>
      <v-col class="caption px-4 pt-2 grey--text" :style="`color: ${backgroundColor};`">
        Score {{ result.score.toPrecision(3) }}
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import { computed, ref } from '@vue/composition-api';
import useWorkspace from '@/views/Context/use/useWorkspace';
import useSearch from '@/views/Context/use/useSearch';
import PageTypeIcon from '@/components/ContextDoc/PageTypeIcon';
export default {
  props: {
    result: Object,
    maxChildren: {
      default: 2,
      type: Number
    },
    showBreadCrumbs: {
      default: true,
      type: Boolean
    }
  },
  components: { PageTypeIcon },
  setup(props) {
    const backgroundColor = computed(() => {
      let color;
      if (props.result.score < -10) {
        color = '#C8E6C9';
      } else if (props.result.score < -9) {
        color = '#B3E5FC';
      } else if (props.result.score < 0) {
        color = '#FFE0B2';
      } else {
        color = 'white';
      }
      return color;
    });
    const { showSearch, toggleShowSearch, toggleShowQuickSearch } = useSearch();
    const { openInTab } = useWorkspace();
    const parent = computed(() => {
      if (props.result.isInANoteCard && props.result.breadcrumbs.length < 2) {
        return false;
      }
      return props.result.breadcrumbs[props.result.breadcrumbs.length - 1];
    });
    // console.log(props.result.type, props.result.title, parent.value.type, parent.value.title);
    return {
      parent,
      backgroundColor,
      openInTab,
      showSearch,
      toggleShowSearch,
      toggleShowQuickSearch
    };
  }
};
</script>

<style>
.section-link:hover {
  background: #f6f6f6;
  cursor: pointer;
}
</style>
